document.addEventListener(
  'dialog:after-show',
  (event) => {
    const drawer = event.target;
    if (!drawer || drawer.id !== 'search-drawer') return;

    const input = drawer.querySelector('#search-drawer-input');
    if (input) {
      requestAnimationFrame(() => input.focus());
    }
  },
  true
);

/* <predictive-search> n'expose qu'un slot à la fois et debounce la saisie : sans troisième
   état, rien ne bouge entre la frappe et l'arrivée des résultats. On bascule sur le slot
   skeleton ; le composant reprend la main en réécrivant son shadowRoot vers les résultats. */
(() => {
  const predictiveSearch = document.getElementById('predictive-search');
  const input = document.getElementById('search-drawer-input');
  if (!predictiveSearch || !input) return;

  const SKELETON = '<slot name="skeleton"></slot>';
  const PLACEHOLDER = '<slot name="placeholder"></slot>';
  const STUCK_DELAY = 10000;
  let stuckTimer;

  input.addEventListener('input', () => {
    /* shadowRoot est null tant que le custom element n'a pas été upgradé. */
    const shadow = predictiveSearch.shadowRoot;
    if (!shadow) return;
    if (input.value.trim() === '') return;
    if (shadow.innerHTML === SKELETON) return;

    shadow.innerHTML = SKELETON;

    /* Un fetch en erreur n'est pas rattrapé par le composant : le skeleton resterait affiché indéfiniment. */
    clearTimeout(stuckTimer);
    stuckTimer = setTimeout(() => {
      if (shadow.innerHTML === SKELETON) {
        shadow.innerHTML = PLACEHOLDER;
      }
    }, STUCK_DELAY);
  });

  const results = predictiveSearch.querySelector('[slot="results"]');
  if (!results) return;

  const fadeIn = (image) => {
    image.setAttribute('data-ax-fade', '');

    if (image.complete) {
      image.classList.add('is-loaded');
      return;
    }

    const reveal = () => image.classList.add('is-loaded');
    image.addEventListener('load', reveal, { once: true });
    image.addEventListener('error', reveal, { once: true });
  };

  new MutationObserver(() => {
    clearTimeout(stuckTimer);
    results.querySelectorAll('.product-card__image--primary:not([data-ax-fade])').forEach(fadeIn);
  }).observe(results, { childList: true, subtree: true });
})();

/* Le reset natif restaure la valeur par défaut : sur la page résultats l'input porte value="{{ search.terms }}", donc la croix ne viderait rien. */
document.addEventListener('reset', (event) => {
  const input = event.target.querySelector?.('.ax-search__input');
  if (!input) return;

  event.preventDefault();
  input.value = '';
  input.focus();
});
